import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const locationLogService = new CachedService(entities.Orderadmin_Storage_Entity_LocationLog, '/storage/location-log', HALApiService, createItemsData)
